export const WALLET_CONNECT = 'WALLET_CONNECT';
export const NETWORK = 'NETWORK';